import { lifecycle } from 'recompose';
import { path } from 'ramda';

import { gtag } from 'app/analytics/trackers/adWords';

const googleAdWordsPixelKey = path(
  ['etp', 'config', 'analytics', 'googleAdWordsPixelKey'],
  window,
);

const withGoogleAdWordsConversion = lifecycle({
  componentDidMount() {
    gtag('event', 'conversion', {
      send_to: `${googleAdWordsPixelKey}/7g8LCOyI3wkQ7Pmg1AM`,
    });
  },
});

export { withGoogleAdWordsConversion };
